import { cloneDeep } from 'lodash-es';
import { IndexedFilters } from '../types/filters';
import { FilterLabelLookup } from './parse-indexed-filter-for-label';
import { isIndexedNestedFilter } from './remove-selected-filter';
import { isTypeNumberRange } from './filter-menu-type-guards';

/**
 * Adds the specified filter to the selected filters state.
 *
 * @param filter filter to lookup and add
 * @param selectedFilters current selected filters
 * @returns selected filters with the new filter added
 */
export default function addSelectedFilter(
  filter: FilterLabelLookup,
  selectedFilters: IndexedFilters
) {
  const updatedFilters = cloneDeep(selectedFilters);
  const currentValue = updatedFilters[filter.key];

  // Create new filter
  if (currentValue === undefined) {
    if (filter.key === 'makes') {
      // Create nested filter for makes & models
      updatedFilters[filter.key] = {
        [filter.subKey as string]: [filter.value as string],
      };
    } else {
      // Create new filter
      if (Array.isArray(filter.value) && !isTypeNumberRange(filter.value)) {
        updatedFilters[filter.key] = filter.value;
      } else if (typeof filter.value !== 'object') {
        updatedFilters[filter.key] = [filter.value];
      }
    }
    return updatedFilters;
  }

  // Add to existing filter
  if (Array.isArray(currentValue)) {
    if (Array.isArray(filter.value)) {
      updatedFilters[filter.key] = filter.value
        .filter((value) => !currentValue.includes(value))
        .concat(currentValue);
    } else if (typeof filter.value !== 'object') {
      if (!currentValue.includes(filter.value)) {
        updatedFilters[filter.key] = [...currentValue, filter.value];
      }
    }
    return updatedFilters;
  }

  if (isIndexedNestedFilter(currentValue) && filter.subKey) {
    // Note: we make an assumption that nested filters will never have buckets of values
    const currentSubValue = currentValue[filter.subKey];
    if (!currentSubValue.includes(filter.value as string)) {
      const newSubValue = [...currentSubValue, filter.value as string];
      updatedFilters[filter.key] = {
        ...currentValue,
        [filter.subKey]: newSubValue,
      };
    }
  }

  return updatedFilters;
}
